<template>
	<div class="BuildCodingTest-main-container">
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="d-flex align-items-center position-relative">
			<div class="d-flex" @click="goBack(false)">
				<img
					src="../../assets/icons/Reports/bckarrow.svg"
					alt=""
					class="pointer"
				/>
			</div>
			<div class="tc-yellow-position">
				<img src="../../assets/yellowOval.svg" alt="" />
			</div>
			<div class="tc-main-head ml-3" style="z-index: 2">Try Question</div>
		</div>
		<template>
			<div>
				<div class="tc-preview-container d-flex mb-1 mt-3">
					<div class="tc-preview-left" style="width: 50%">
						<div class="d-flex align-items-center">
							<div class="tc-preview-head">Question</div>
						</div>
						<div
							class="tc-card-subtext mt-3 mb-4 ml-2"
							style="width: 86%; margin: 12px 0px 25px 9px"
							v-html-safe="questionData.question"
						></div>
						<div class="tc-TC-card p-3 m-2">
							<span class="tc-preview-head">Constrain</span>
							<div
								class="mt-3 tc-card-subtext"
								v-html-safe="questionData.constraints"
							></div>
						</div>
						<div class="tc-TC-card p-3 m-2">
							<span class="tc-preview-head">Sample</span>

							<div class="p-3 tc-card-subtext d-flex flex-column">
								<span>
									<span> Input: </span>
									<span v-html-safe="questionData.sampleInput"></span>
								</span>
								<span>
									<span> Output: </span>
									<span v-html-safe="questionData.sampleOutput"></span>
								</span>
							</div>
						</div>
						<div class="tc-TC-card p-3 m-2">
							<span class="tc-preview-head">Test Cases</span>
							<div class="d-flex">
								<div class="tc-many-testCase-left" style="width: 25%">
									<!--********************   SELECTED TEST CASE CLASS  *********************-->

									<!--********************   UNSELECTED TEST CASE  CLASS *********************-->
									<div
										class="p-2 tc-many-testCase-text pointer d-flex justify-content-between"
										v-for="(i, index) in questionData.testCases"
										:key="index"
										@click="showTestCase(i, index)"
										:class="{
											'tc-many-testCase-sel-text': selectedTestCase === index,
										}"
									>
										Test Case {{ index + 1 }}
										<img v-if="!i.visible" src="../../assets/no-view.svg" />
									</div>
								</div>
								<div class="tc-many-testCase-right" style="width: 75%">
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Input</span>
										<div
											class="tc-card-subtext ml-3 mt-2"
											v-html-safe="seltcaseInput"
										></div>
									</div>
									<div class="tc-TC-card p-3 m-2">
										<span class="tc-preview-head">Output</span>
										<div
											class="tc-card-subtext ml-3 mt-2"
											v-html-safe="seltcaseOutput"
										></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="tc-preview-line-box" style="width: 1%"></div>
					<div style="width: 49%; overflow: auto" class="ml-3" ref="codediv">
						<div class="d-flex justify-content-end">
							<div style="width: 40%" class="position-relative mr-2">
								<div
									@click="showtopiccard = !showtopiccard"
									class="cq-lang-container d-flex align-items-center justify-content-between"
								>
									<div class="cq-accept-lang">Accepted Language</div>
									<div class="cq-langline"></div>
									<div class="cq-lang-text">
										{{ topicCardselected }}
										<img class="ml-3" src="../../assets/downarrow.svg" alt="" />
									</div>
								</div>
								<div v-if="showtopiccard" class="cq-selectLang-cont">
									<b-form-group
										class="cq-typeradio"
										v-for="(i, index) in arrayFromData"
										:key="index"
									>
										<b-form-radio
											class="m-1"
											size="sm"
											v-model="topicCardselected"
											:value="i.languageName"
											@change="getTopicValue(i)"
										>
											{{ i.languageName }}
										</b-form-radio>
									</b-form-group>
								</div>
							</div>
							<img
								v-b-popover.hover.top="'Full Screen'"
								src="../../assets/fullscreen.svg"
								alt=""
								srcset=""
								class="pointer"
								@click="showInFullScreen()"
								style="margin-left: 15px"
							/>
						</div>
						<div class="editorContainer bct-code-body w-100 mt-2"></div>

						<div class="d-flex justify-content-end mt-3 mr-1">
							<b-button
								:disabled="runningcode"
								class="tc-save-btn"
								@click="runCodeForCompilation()"
								>Run Code</b-button
							>
						</div>
						<div
							v-show="showResult"
							ref="scrollContainer"
							class="bg-white"
							style="
								box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
								border-radius: 5px;
							"
						>
							<div class="tc-test-result mt-2 mb-4 mr-1 p-2">Test Result</div>
							<div class="tc-bottom-button m-1 mr-1 p-2">
								<div v-if="failedtestcase > 0">
									<div class="tc-redTop">
										Compilation Failed -
										{{ failedtestcase }}/{{ questionData.testCases.length }}
										test cases Failed
									</div>
									<div class="p-2">
										<span class="tc-preview-head"> Compile Message </span>
										<div class="tc-card-subtext mt-4">
											{{ compileMessage.stderr }}
										</div>
									</div>
								</div>
								<div class="tc-greenTop" v-else>
									Completed Successfully - All test cases are passed
								</div>
								<hr />
								<img class="ml-2" src="../../assets/nonView.svg" alt="" /><span
									class="tc-preview-head ml-2"
									>Invisible test Cases for candidate</span
								>
								<div class="p-2">
									<span class="tc-preview-head">Test Cases</span>
									<div class="d-flex mt-4">
										<div class="tc-many-trialCase-left" style="width: 25%">
											<div
												class="p-2 tc-many-testCase-text pointer"
												v-for="(data, i) in executionData"
												:class="
													showIcon == i
														? 'tc-many-testCase-sel-text pointer'
														: 'p-2 tc-many-testCase-text pointer'
												"
												:key="i"
												@click="hideIcon(i, data)"
											>
												<img
													v-if="data.testStatus == 'PASSED'"
													class="mr-1"
													src="../../assets/testCasePass.svg"
													alt=""
												/>
												<img
													v-else
													class="mr-1"
													src="../../assets/testCaseFail.svg"
													alt=""
												/>
												Test Case {{ i + 1 }}
												<img
													v-if="!data.visible"
													class="ml-2"
													src="../../assets/nonView.svg"
													alt=""
												/>
											</div>
										</div>
										<div class="tc-many-testCase-right" style="width: 75%">
											<div class="tc-TC-card p-3 m-2">
												<span class="tc-preview-head">Input</span>
												<div class="tc-card-subtext ml-3 mt-2">
													{{ showTestCaseData.inputValue }}
												</div>
											</div>
											<div class="tc-TC-card p-3 m-2">
												<span class="tc-preview-head">Expected Output</span>
												<div class="tc-card-subtext ml-3 mt-2">
													{{ showTestCaseData.outputValue }}
												</div>
											</div>
											<div class="tc-TC-card p-3 m-2">
												<span class="tc-preview-head">Your Output</span>
												<div class="tc-card-subtext ml-3 mt-2">
													{{ showTestCaseData.stdout || "null" }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="tc-bottom-button d-flex align-items-center justify-content-between"
				>
					<div class="d-flex">
						<div class="tc-cancel-btn-parent">
							<b-button class="tc-cancel-btn mr-3" @click="goBack(false)"
								>Back to Questions</b-button
							>
						</div>
						<div class="tc-cancel-btn-parent">
							<b-button class="tc-save-btn mr-4" @click="goBack(true)"
								>Edit Question</b-button
							>
						</div>
					</div>
					<div class="bct-cancel-btn-parent">
						<b-button
							v-if="this.$route.query.status != 1"
							class="tc-save-btn"
							@click="exitTryCode()"
							>Save & Next</b-button
						>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import {
	getcodingquestion,
	codecompileforeachcase,
	addcodingquestion,
} from "../../utils/apiFunctions.js";
import availableLanguages from "./codeSnip";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import toastFunction from "../../views/mixin/toast";
export default {
	name: "tryCode",
	mixins: [toastFunction],
	data() {
		return {
			compileMessage: {},
			executionData: [],
			failedtestcase: 0,
			allTestCases: [],
			runningcode: false,
			LoaderStatus: false,
			showIcon: null,
			loopVar: 2,
			loopVar2: 5,
			showResult: false,
			lastWindowSize: {
				width: window.innerWidth,
				height: window.innerHeight,
			},
			compiledTestCasesResult: {},
			questionData: {},
			selectedTestCase: 0,
			editorInstance: null,
			selectedTestCaseData: {
				inputValue: "",
				outputValue: "",
				visible: false,
			},
			totaldataforalllang: [],
			topicCardselected: null,
			showtopiccard: false,
			arrayFromData: [],
			activeForTopic: {},
			showTestCaseData: {},
			showTestCaseDataforclick: false,
			currentLangId: null,
			currentbody: null,
			currentlang: null,
		};
	},
	components: {
		Spinner,
	},
	created() {
		this.LoaderStatus = true;
		this.getQuestion(this.$route.query.questionKey);
	},
	mounted() {
		// window.addEventListener("resize", this.handleZoomChange);
		this.debouncedResize = this.debounce(this.handleZoomChange, 200);
		window.addEventListener("resize", this.debouncedResize);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.debouncedResize);
	},
	watch: {
		allTestCases() {
			let testcase = 0;
			this.allTestCases.map((data) => {
				testcase = testcase + data.totalTestCasesFailed;
			});
		},

		lastWindowSize() {
			if (this.editorInstance) {
				this.editorInstance.layout(); // resize editor only
			}
		},
	},
	computed: {
		tcaseInput() {
			return this.showTestCaseData.inputValue.replace(/\n/g, "<br>");
		},
		tcaseOutput() {
			console.log(this.showTestCaseData.outputValue.replace(/\n/g, "<br>"));
			return this.showTestCaseData.outputValue.replace(/\n/g, "<br>");
		},
		seltcaseInput() {
			return this.selectedTestCaseData.inputValue.replace(/\n/g, "<br>");
		},
		seltcaseOutput() {
			return this.selectedTestCaseData.outputValue.replace(/\n/g, "<br>");
		},
		compilemsg() {
			return this.compileMessage.data.replace(/\n/g, "<br>");
		},
	},

	methods: {
		debounce(func, wait = 200) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(this, args), wait);
			};
		},
		async exitTryCode() {
			if (this.$route.query.status == 1) {
				this.$router.go(-1);
			} else if (this.$route.query.status == 2) {
				this.questionData.status = 2;
				delete this.questionData.active;
				delete this.questionData.actualQuestion;
				delete this.questionData.addToPublic;
				delete this.questionData.addToDatabank;
				delete this.questionData.createdAt;
				delete this.questionData.createdBy;
				delete this.questionData.licenseKey;
				delete this.questionData.questionMedia;
				delete this.questionData.questionMediaType;
				delete this.questionData.updatedAt;
				let res = await addcodingquestion(this.questionData);
				if (res.status == 200) {
					this.successToast("Question created successfully...");
					this.$nextTick(() => {
						this.$router.push({
							name: "QPcodingTest",
						});
					});
				} else {
					this.errorToast("Question saved only as draft....");
					this.$nextTick(() => {
						this.$router.push({
							name: "QPcodingTest",
							query: {
								draft: true,
							},
						});
					});
				}
			} else if (this.$route.query.status == 3) {
				this.$router.push({
					name: "QPcodingTest",
				});
			}
		},
		hideIcon(index, data) {
			this.showTestCaseDataforclick = true;
			this.showTestCaseData = data;
			this.showIcon = index;
			this.scrolldiv();
		},
		handleZoomChange() {
			if (this.editorInstance) {
				this.editorInstance.layout(); // just resize, no new editor
			}
			// this.removeEditor();
		},
		scrolldiv() {
			const scrollableDiv = this.$refs.codediv;
			if (scrollableDiv) {
				console.log(scrollableDiv, "scrollableDiv");
				// Scroll the div down by a specific amount
				scrollableDiv.scrollTop += 10; // Adjust the value as needed
			}
		},
		removeEditor() {
			if (this.editorInstance) {
				this.editorInstance.dispose(); // Dispose the editor instance
				const editorContainer = document.querySelector(".editorContainer");
				while (editorContainer.firstChild) {
					editorContainer.firstChild.remove(); // Remove all child nodes from the editor container
				}
			}
		},
		showInFullScreen() {
			const element = document.querySelector(".editorContainer");

			if (!document.fullscreenElement) {
				this.requestfullscreen(element);
			} else {
				if (document.exitFullscreen) document.exitFullscreen();
				else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
				else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
				else if (document.msExitFullscreen) document.msExitFullscreen();
			}

			// Resize editor after fullscreen toggle
			setTimeout(() => {
				element.style.width = "100vw";
				if (this.editorInstance) this.editorInstance.layout();
			}, 100);
		},
		requestfullscreen(element) {
			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.mozRequestFullScreen) {
				// Firefox
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				// Chrome, Safari, and Opera
				element.webkitRequestFullscreen();
			} else if (element.msRequestFullscreen) {
				// IE/Edge
				element.msRequestFullscreen();
			}
		},
		goBack(back) {
			if (this.questionData.status == 1 && back) {
				let data = {
					name: "BuildingCodeTest",
				};
				data.query = {
					redirect: "QPcodingTest",
					questionKey: this.questionData.questionKey,
				};
				this.$router.push(data);
			} else if (this.questionData.status == 2 && back) {
				this.goToEditQuestion(this.questionData.questionKey);
			} else this.$router.push({ name: "QPcodingTest" });
		},
		goToEditQuestion(key) {
			let data = {
				name: "EditCodingTest",
				query: {
					redirect: "QPcodingTest",
				},
			};
			if (typeof key !== "object") {
				data.query["questionKey"] = key;
			}
			this.$router.push(data);
		},
		normalizeOutput(output) {
			return output?.trim().replace(/\r?\n/g, "").replace(/\s+/g, " ");
		},
		async runCodeForCompilation() {
			this.LoaderStatus = true;
			this.executionData = [];
			this.failedtestcase = 0;
			this.showResult = true;

			const extractedCode = this.editorInstance.getValue();
			console.log(this.topicCardselected, availableLanguages)
			const selected =
				this.topicCardselected === "c++" ? "cpp" : this.topicCardselected;

			let currentlanddetails = availableLanguages.filter(
				(data) => data.language === selected
			);
			console.log(currentlanddetails,"currentlanddetails")
			try {
				// 1️⃣ Create all API promises
				const apiCalls = this.questionData.testCases.map((data) => {
					const payload = {
						language: selected,
						stdin: data.inputValue,
						files: [
							{
								name: currentlanddetails[0].properties.name,
								content: extractedCode,
							},
						],
					};

					return codecompileforeachcase(payload);
				});

				// 2️⃣ Call all APIs at once
				const responses = await Promise.all(apiCalls);

				// 3️⃣ Process responses
				responses.forEach((response, index) => {
					const result = response.data;
					this.compileMessage=result
					const data = this.questionData.testCases[index];

					let testStatus = "PASSED";

					if (result.stderr || result.exception) {
						testStatus = "ERROR";
						this.failedtestcase++;
					} else {
						const actual = this.normalizeOutput(result.stdout);
						const expected = this.normalizeOutput(data.outputValue);

						if (actual !== expected) {
							testStatus = "FAILED";
							this.failedtestcase++;
						}
					}

					this.executionData.push({
						...result,
						...data,
						testStatus,
					});

					this.hideIcon(index, this.executionData[index]);
				});
			} catch (error) {
				console.error(error);
			} finally {
				this.LoaderStatus = false;

				this.$refs.scrollContainer?.scrollIntoView({
					behavior: "smooth",
					block: "end",
				});
			}
		},
		initializeEditor() {
			let snip = this.currentbody;
			const editorContainer = document.querySelector(".editorContainer");
			window.require.config({
				paths: {
					vs: "https://cdn.jsdelivr.net/npm/monaco-editor@latest/min/vs",
				},
			});
			window.require(["vs/editor/editor.main"], () => {
				this.editorInstance = window.monaco.editor.create(editorContainer, {
					value: snip,
					language: this.currentlang == "c++" ? "cpp" : this.currentlang,
					theme: "vs-dark",
				});
			});
		},

		getTopicValue(data) {
			this.currentLangId = data.id;
			this.currentbody = data.body;
			this.currentlang = data.languageName;
			this.activeForTopic = data;
			this.showtopiccard = false;
			this.removeEditor();
			this.initializeEditor();
		},
		topicFunction() {
			this.showtopiccard = !this.showtopiccard;
			this.$forceUpdate();
		},
		showTestCase(data, index) {
			this.selectedTestCase = index;
			this.selectedTestCaseData = data;
		},

		async getQuestion(key) {
			const res = await getcodingquestion(key);
			console.log(res.status);
			if (res.status == 200) {
				this.questionData = res.data.data;
				console.log(res.data.data);
				this.arrayFromData = Object.entries(res.data.data.defaultBody).map(
					([key, value]) => ({ id: key, ...value })
				);
				this.activeForTopic = this.arrayFromData[0];
				this.topicCardselected = this.arrayFromData[0].languageName;
				this.currentLangId = this.arrayFromData[0].id;
				this.currentbody = this.arrayFromData[0].body;
				this.currentlang = this.arrayFromData[0].languageName;
				setTimeout(() => {
					this.initializeEditor();
					this.LoaderStatus = false;
				}, 800);
				this.showTestCase(this.questionData.testCases[0], 0);
			}
		},
	},
};
</script>
<style>
.not-allowed {
	cursor: not-allowed;
}
.showClickedTestCase {
	font-weight: 600 !important;
	font-size: 14px !important;
}
.cq-lang-container {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 15px;
}

.cq-langline {
	border: 1px solid #c4c4c4;
	width: 0px;
	height: 12px;
}

.cq-accept-lang {
	font-weight: 400;
	font-size: 12px;
	color: #464667;
}

.cq-lang-text {
	font-weight: 500;
	font-size: 12px;
	color: #464667;
}
.cq-selectLang-cont {
	position: absolute;
	border-radius: 5px;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	background: #fff;
	box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
	z-index: 1000;
	width: 100%;
	height: fit-content;
	max-height: 163px;
	overflow: auto;
}
.cq-typeradio:nth-child(odd) {
	background: #f4f4f4;
}

.cq-typeradio:nth-child(even) {
	background: #fdfdfd;
}

.cq-selectLang-cont .form-group {
	margin-bottom: 0px;
}
.BuildCodingTest-main-container {
	padding: 90px 20px 0px 80px;
}

.tc-yellow-position {
	position: absolute;
	left: 22px;
	z-index: 1;
}

.tc-main-head {
	font-weight: 600;
	font-size: 18px;
	color: #464667;
}

.tc-ques {
	position: absolute;
	left: 250px;
	top: 15px;
}

.tc-bottom-button {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
}

.tc-cancel-btn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc-save-btn {
	background: #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.BuildCodingTest-main-container .tc-cancel-btn-parent .btn-secondary:focus,
.btn-secondary.focus {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.BuildCodingTest-main-container .tc-cancel-btn-parent .btn-secondary:hover {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc .tc-cancel-btn-parent .btn-secondary:focus,
.btn-secondary.focus {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc .tc-cancel-btn-parent .btn-secondary:hover {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}

.tc-select:focus {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.tc-select:hover {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.tc-select:active {
	border: 0.7px solid rgba(10, 86, 200, 0.5);
}

.cke_bottom {
	display: none !important;
}

.cke_chrome {
	display: block;
	background: #fdfdfd;
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.25) !important;
	border-radius: 3px !important;
	padding: 0;
}

.tc-ck1 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 180px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.tc-ck2 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 145px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.tc-ck3 .cke_inner {
	display: block;
	background: #fdfdfd !important;
	height: 190px !important;
	padding: 0;
	-webkit-touch-callout: none;
	border-radius: 5px !important;
}

.tc-ck1 .cke_contents {
	display: block;
	height: 115px !important;
	overflow: hidden;
}

.tc-ck2 .cke_contents {
	display: block;
	height: 85px !important;
	overflow: hidden;
}

.tc-ck3 .cke_contents {
	display: block;
	height: 125px !important;
	overflow: hidden;
}

.cke_top {
	border-bottom: 1px solid #ececec !important;
	background: #f8f8f8;
	padding: 6px 8px 2px;
	white-space: normal;
	border-radius: 3px !important;
}

.cke_wysiwyg_frame,
.cke_wysiwyg_div {
	background-color: #fff;
	border-radius: 3px !important;
}

.cke_reset {
	margin: 0;
	padding: 0;
	border: 0;
	background: transparent;
	text-decoration: none;
	width: auto;
	height: auto;
	vertical-align: baseline;
	box-sizing: content-box;
	position: static;
	transition: none;
}

.BuildCodingTest-main-container .form-control {
	border: 0.7px solid rgba(10, 86, 200, 0.5) !important;
}
.b-form-tags input::placeholder {
	color: #6d6d6d !important;
	opacity: unset;
}
.tc-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.tc-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}

.tc-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 335px);
	color: #ffffff;
	font-size: 14px;
}
.bct-code-body {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: hidden;
	height: calc(100vh - 365px);
	color: #ffffff;
	font-size: 14px;
}

.bct-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	color: #ffffff;
	font-size: 14px;
}

.tc-preview-container {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	height: calc(100vh - 205px);
	padding: 20px;
}

.tc-preview-line-box {
	border-right: 0.5px solid #adaaaa;
	height: calc(100vh - 245px);
}

.tc-preview-left {
	overflow: auto;
}

.tc-preview-head {
	font-size: 13px;
	font-weight: 500;
	color: #333333;
}

.tc-many-testCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
}

.tc-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}

.tc-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
}

.tc-many-testCase-sel-text {
	font-weight: 600;
	font-size: 14px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}

.tc-many-trialCase-sel-text {
	background: #eef2f5;
}

.tc-many-trialCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #ffffff;
	border: 1px solid rgba(196, 196, 196, 0.25);
	border-radius: 3px;
}

.tc-test-result {
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}

.tc-greenTop {
	background: #1cb803;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.tc-redTop {
	background: #f15c6a;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.tc-greenText {
	font-weight: 500;
	font-size: 12px;
	color: #1cb803;
}
.topic-container {
	width: 300px;
}

.sorttext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 400;
	font-size: 12px;
}
.sortline {
	width: 0px;
	height: 19px;
	border: 1px solid #c4c4c4;
	background: #c4c4c4;
}
.top-downarrowAlgn {
	margin-bottom: 2px;
}
.tnt-sortcardcode {
	background: var(--bg-white);
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
	border-radius: 5px;
	top: 32px;
	right: 0px;
	padding: 5px 15px;
	position: absolute;
	z-index: 7;
	width: 204px;
	font-weight: 600;
	font-size: var(--size-13);
	color: #545454;
}
.jdtyperadio:nth-child(odd) {
	background: #f4f4f4;
}

.jdtyperadio:nth-child(even) {
	background: #fdfdfd;
}
.sortordertext {
	font-family: "Poppins", sans-serif;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
}
</style>
